// extracted by mini-css-extract-plugin
export default {"autocomplete":"a3_B8","option":"b3_B8","subLabel":"c3_B8"};